(function () {
  'use strict';

  var FORCE_OPEN_HOURS_PREVIEW = false; // Debug only: force available-hours UI
  var EMAIL_PROMPT_DELAY = 600;

  var BUSINESS_SCHEDULE = {
    timeZone: 'America/Los_Angeles',
    days: [
      null,
      { name: 'Monday', open: 510, close: 1020 },
      { name: 'Tuesday', open: 510, close: 1020 },
      { name: 'Wednesday', open: 510, close: 1020 },
      { name: 'Thursday', open: 510, close: 1020 },
      { name: 'Friday', open: 510, close: 1020 },
      { name: 'Saturday', open: 540, close: 780 }
    ]
  };

  var WEEKDAY_INDEX = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6
  };

  function losAngelesParts(date) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: BUSINESS_SCHEDULE.timeZone,
      weekday: 'long',
      hour: 'numeric',
      minute: '2-digit',
      hourCycle: 'h23'
    });
    var values = {};
    formatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });
    var hour = Number(values.hour);
    if (hour === 24) hour = 0;
    return {
      day: WEEKDAY_INDEX[values.weekday],
      hour: hour,
      minute: Number(values.minute)
    };
  }

  function displayTime(totalMinutes) {
    var hour = Math.floor(totalMinutes / 60);
    var minute = totalMinutes % 60;
    var suffix = hour >= 12 ? 'PM' : 'AM';
    var displayHour = hour % 12 || 12;
    return displayHour + (minute ? ':' + String(minute).padStart(2, '0') : '') + ' ' + suffix;
  }

  function nextOpeningCopy(currentDay, dayOffset, nextDay, openMinutes) {
    if (dayOffset === 0) return "We'll be back at " + displayTime(openMinutes);
    if (dayOffset === 1 && nextDay !== 1 && nextDay !== 6) return "We'll be back tomorrow";
    return "We'll be back " + BUSINESS_SCHEDULE.days[nextDay].name;
  }

  function getBusinessStatus(date) {
    var parts;
    try {
      parts = losAngelesParts(date || new Date());
    } catch (error) {
      return {
        isOpen: false,
        nextOpeningCopy: "We'll be back soon"
      };
    }

    var minutes = (parts.hour * 60) + parts.minute;
    var today = BUSINESS_SCHEDULE.days[parts.day];
    if (today && minutes >= today.open && minutes < today.close) {
      return {
        isOpen: true,
        nextOpeningCopy: ''
      };
    }

    if (today && minutes < today.open) {
      return {
        isOpen: false,
        nextOpeningCopy: nextOpeningCopy(parts.day, 0, parts.day, today.open)
      };
    }

    for (var offset = 1; offset <= 7; offset += 1) {
      var nextDay = (parts.day + offset) % 7;
      var nextSchedule = BUSINESS_SCHEDULE.days[nextDay];
      if (nextSchedule) {
        return {
          isOpen: false,
          nextOpeningCopy: nextOpeningCopy(parts.day, offset, nextDay, nextSchedule.open)
        };
      }
    }

    return {
      isOpen: false,
      nextOpeningCopy: "We'll be back soon"
    };
  }

  window.ERSMessageBusinessHours = {
    getStatus: getBusinessStatus,
    timeZone: BUSINESS_SCHEDULE.timeZone
  };

  function initProductMessageWidget() {
    var widget = document.querySelector('[data-ers-message-widget]');
    if (!widget || widget._ersMessageWidget) return;
    widget._ersMessageWidget = true;

    var launcher = widget.querySelector('[data-ers-message-open]');
    var panel = widget.querySelector('[data-ers-message-panel]');
    var closeButtons = widget.querySelectorAll('[data-ers-message-close]');
    var startButton = widget.querySelector('[data-ers-message-start]');
    var backButton = widget.querySelector('[data-ers-message-back]');
    var form = widget.querySelector('.ers-message-form');
    var composer = widget.querySelector('[data-ers-message-composer]');
    var conversation = widget.querySelector('[data-ers-message-conversation]');
    var landingCopy = widget.querySelector('[data-ers-message-landing-copy]');
    var greeting = widget.querySelector('[data-ers-message-greeting]');
    var greetingBubble = widget.querySelector('[data-ers-message-greeting-bubble]');
    var confirmation = widget.querySelector('[data-ers-message-confirmation]');
    var messageBody = widget.querySelector('[data-ers-message-body]');
    var emailInput = widget.querySelector('[data-ers-message-email]');
    var continueButton = widget.querySelector('[data-ers-message-continue]');
    var quickActions = widget.querySelectorAll('[data-ers-message-quick-action]');
    var quickActionsContainer = widget.querySelector('.ers-message-quick-actions');
    var skipButton = widget.querySelector('[data-ers-message-skip]');
    var submitButton = widget.querySelector('[data-ers-message-submit]');
    var composeStep = widget.querySelector('[data-ers-message-compose-step]');
    var emailStep = widget.querySelector('[data-ers-message-email-step]');
    var savedBubble = widget.querySelector('[data-ers-message-saved-bubble]');
    var savedBody = widget.querySelector('[data-ers-message-saved-body]');
    var emailPrompt = widget.querySelector('[data-ers-message-email-prompt]');
    var awayStatus = widget.querySelector('[data-ers-message-away-status]');
    var bodyError = widget.querySelector('[data-ers-message-body-error]');
    var emailError = widget.querySelector('[data-ers-message-email-error]');
    var serverErrors = widget.querySelector('[data-ers-message-errors]');
    var success = widget.querySelector('[data-ers-message-success]');
    var successFooter = widget.querySelector('[data-ers-message-success-footer]');
    var urlInput = widget.querySelector('[data-ers-message-url]');
    var skuInput = widget.querySelector('[data-ers-message-sku]');
    var productSection = skuInput ? document.getElementById('ProductSection') : null;
    var returnStateKey = 'ers-message-return';
    var businessStatus;
    var responseDelayTimer = null;
    var closeTransitionTimer = null;
    var closeTransitionHandler = null;
    var selectedBranch = '';
    var branchStep = 'initial';
    var branchAnswers = {};

    function focusElement(element) {
      if (!element) return;
      element.focus({ preventScroll: true });
    }

    function applyBusinessStatus(date) {
      var calculatedStatus = getBusinessStatus(date);
      businessStatus = FORCE_OPEN_HOURS_PREVIEW
        ? { isOpen: true, nextOpeningCopy: calculatedStatus.nextOpeningCopy }
        : calculatedStatus;
      widget.setAttribute('data-business-status', businessStatus.isOpen ? 'open' : 'closed');
      if (landingCopy) {
        landingCopy.textContent = businessStatus.isOpen ? 'How can we help?' : businessStatus.nextOpeningCopy;
      }
      if (greeting) {
        greeting.textContent = businessStatus.isOpen
          ? 'Hi! How can we help?'
          : "Leave us a message and we'll get back to you during business hours.";
      }
      if (confirmation) {
        confirmation.textContent = businessStatus.isOpen
          ? "Thanks — we've received your message. We'll reply by email."
          : "Thanks — we've received your message. We'll get back to you during business hours.";
      }
      if (backButton) backButton.hidden = businessStatus.isOpen;
      if (awayStatus) {
        awayStatus.hidden = businessStatus.isOpen;
        if (businessStatus.isOpen) {
          awayStatus.textContent = '';
        } else if (businessStatus.nextOpeningCopy.indexOf("We'll be back at ") === 0) {
          awayStatus.textContent = '\u25f7 Back at ' + businessStatus.nextOpeningCopy.replace("We'll be back at ", '');
        } else if (businessStatus.nextOpeningCopy === "We'll be back tomorrow") {
          awayStatus.textContent = '\u25f7 Back tomorrow';
        } else if (businessStatus.nextOpeningCopy.indexOf("We'll be back ") === 0) {
          awayStatus.textContent = '\u25f7 Back on ' + businessStatus.nextOpeningCopy.replace("We'll be back ", '');
        } else {
          awayStatus.textContent = '\u25f7 Back soon';
        }
      }
      return businessStatus;
    }

    function activeView() {
      return widget.querySelector('[data-ers-message-view="' + widget.getAttribute('data-state') + '"]');
    }

    function focusCurrentState() {
      if (widget.getAttribute('data-state') === 'landing') {
        focusElement(landingCopy);
        return;
      }
      if (success && !success.hidden) {
        focusElement(success);
        return;
      }
      if (widget.getAttribute('data-message-step') === 'email') {
        focusElement(serverErrors && !serverErrors.hidden ? serverErrors : emailInput);
        return;
      }
      focusElement(messageBody || activeView().querySelector('[data-ers-message-screen-heading]'));
    }

    function setView(state, focus) {
      widget.setAttribute('data-state', state);
      widget.querySelectorAll('[data-ers-message-view]').forEach(function (view) {
        var isActive = view.getAttribute('data-ers-message-view') === state;
        view.hidden = !isActive;
        view.classList.toggle('is-active', isActive);
      });
      if (focus) focusCurrentState();
    }

    function restorePagePosition(savedState) {
      if (!savedState) return;
      var root = document.documentElement;
      var originalScrollBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(savedState.x || 0, savedState.y || 0);
      root.style.scrollBehavior = originalScrollBehavior;
    }

    function openWidget(focus, savedState) {
      if (widget.classList.contains('is-closing')) return;
      applyBusinessStatus();
      restorePagePosition(savedState);
      if (!(success && !success.hidden) && !(serverErrors && !serverErrors.hidden)) {
        if (businessStatus.isOpen) {
          if (composer) composer.hidden = false;
          if (greetingBubble) greetingBubble.hidden = false;
          setMessageStep('message', false, false);
          setView('messaging', false);
        } else {
          setView('landing', false);
        }
      }
      widget.classList.add('is-open');
      launcher.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      if (focus) focusCurrentState();
    }

    function cancelResponseDelay() {
      if (!responseDelayTimer) return;
      window.clearTimeout(responseDelayTimer);
      responseDelayTimer = null;
    }

    function clearCloseTransitionCompletion() {
      if (closeTransitionTimer) {
        window.clearTimeout(closeTransitionTimer);
        closeTransitionTimer = null;
      }
      if (closeTransitionHandler) {
        panel.removeEventListener('transitionend', closeTransitionHandler);
        closeTransitionHandler = null;
      }
    }

    function resetInteraction() {
      cancelResponseDelay();
      selectedBranch = '';
      branchStep = 'initial';
      branchAnswers = {};
      clearTransientConversation();
      try {
        window.sessionStorage.removeItem(returnStateKey);
      } catch (error) {
        // Native submission state is only needed across its immediate reload.
      }
      if (messageBody) {
        messageBody.value = '';
        messageBody.removeAttribute('aria-invalid');
      }
      if (emailInput) {
        emailInput.value = '';
        emailInput.removeAttribute('aria-invalid');
      }
      if (savedBody) savedBody.textContent = '';
      if (savedBubble) savedBubble.hidden = true;
      if (emailPrompt) emailPrompt.hidden = true;
      if (bodyError) bodyError.hidden = true;
      if (emailError) emailError.hidden = true;
      if (serverErrors) serverErrors.hidden = true;
      if (success) success.hidden = true;
      if (successFooter) successFooter.hidden = true;
      if (greetingBubble) greetingBubble.hidden = false;
      if (composer) composer.hidden = false;
      widget.setAttribute('data-message-step', 'message');
      if (composeStep) composeStep.hidden = false;
      if (emailStep) emailStep.hidden = true;
      configureComposer();
      resizeMessageInput();
      setView('landing', false);
    }

    function finishClose() {
      if (!widget.classList.contains('is-closing')) return;
      clearCloseTransitionCompletion();
      widget.classList.remove('is-closing');
      resetInteraction();
      panel.setAttribute('aria-hidden', 'true');
      focusElement(launcher);
    }

    function closeWidget() {
      if (!widget.classList.contains('is-open') || widget.classList.contains('is-closing')) return;
      cancelResponseDelay();
      widget.classList.add('is-closing');
      widget.classList.remove('is-open');
      launcher.setAttribute('aria-expanded', 'false');
      clearCloseTransitionCompletion();

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.requestAnimationFrame(finishClose);
        return;
      }

      closeTransitionHandler = function (event) {
        if (event.target === panel && event.propertyName === 'opacity') finishClose();
      };
      panel.addEventListener('transitionend', closeTransitionHandler);
      closeTransitionTimer = window.setTimeout(finishClose, 240);
    }

    function visibleFocusableElements() {
      return Array.prototype.filter.call(panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ), function (element) {
        return !element.hidden && element.getClientRects().length > 0;
      });
    }

    function containFocus(event) {
      if (event.key !== 'Tab' || (!widget.classList.contains('is-open') && !widget.classList.contains('is-closing'))) return;
      var focusable = visibleFocusableElements();
      if (!focusable.length) {
        event.preventDefault();
        focusElement(panel);
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var activeInside = panel.contains(document.activeElement);
      if (event.shiftKey && (!activeInside || document.activeElement === first)) {
        event.preventDefault();
        focusElement(last);
      } else if (!event.shiftKey && (!activeInside || document.activeElement === last)) {
        event.preventDefault();
        focusElement(first);
      }
    }

    function scrollConversationToEnd() {
      if (!conversation) return;
      window.requestAnimationFrame(function () {
        conversation.scrollTop = conversation.scrollHeight;
      });
    }

    function setMessageStep(step, focus, preserveServerErrors) {
      if (!composeStep || !emailStep) return;
      widget.setAttribute('data-message-step', step);
      composeStep.hidden = step !== 'message';
      emailStep.hidden = step !== 'email';
      if (emailPrompt) emailPrompt.hidden = step !== 'email';
      if (serverErrors && !preserveServerErrors) serverErrors.hidden = true;
      if (step === 'message' && bodyError) {
        bodyError.hidden = true;
        messageBody.removeAttribute('aria-invalid');
      }
      scrollConversationToEnd();
      if (focus) focusElement(step === 'email' ? emailInput : messageBody);
    }

    function resizeMessageInput() {
      if (!messageBody) return;
      messageBody.style.height = 'auto';
      messageBody.style.height = Math.min(messageBody.scrollHeight, 100) + 'px';
    }

    function clearTransientConversation() {
      widget.querySelectorAll('[data-ers-message-transient]').forEach(function (bubble) {
        bubble.remove();
      });
    }

    function addConversationBubble(message, type) {
      if (!conversation || !message) return;
      var bubble = document.createElement('div');
      var copy = document.createElement('p');
      bubble.className = 'ers-message-bubble ers-message-bubble--' + type;
      bubble.setAttribute('data-ers-message-transient', '');
      copy.textContent = message;
      bubble.appendChild(copy);
      conversation.insertBefore(bubble, savedBubble || emailPrompt || null);
      scrollConversationToEnd();
    }

    function configureComposer() {
      var placeholder = 'Write a message...';
      var errorCopy = 'Please write a message first.';
      var showSkip = false;

      if (selectedBranch === 'Track Order' && branchStep === 'order-number') {
        placeholder = 'Order number';
        errorCopy = 'Please enter your order number.';
      } else if (selectedBranch === 'Track Order' && branchStep === 'additional-details') {
        placeholder = 'Add optional details...';
        showSkip = true;
      } else if (selectedBranch === 'Product Question' && branchStep === 'product') {
        placeholder = 'Product name or description...';
      } else if (selectedBranch === 'Product Question' && branchStep === 'question') {
        placeholder = 'Write your question...';
      } else if (selectedBranch === 'Report Issue') {
        placeholder = 'Tell us what happened...';
      }

      if (messageBody) messageBody.placeholder = placeholder;
      if (bodyError) bodyError.textContent = errorCopy;
      if (quickActionsContainer) quickActionsContainer.hidden = branchStep !== 'initial';
      if (skipButton) skipButton.hidden = !showSkip;
    }

    function beginResponseDelay(callback) {
      cancelResponseDelay();
      setMessageStep('pending', false, false);
      responseDelayTimer = window.setTimeout(function () {
        responseDelayTimer = null;
        if (!widget.classList.contains('is-open') || widget.getAttribute('data-message-step') !== 'pending') return;
        callback();
      }, EMAIL_PROMPT_DELAY);
    }

    function showBranchPrompt(prompt, nextStep) {
      addConversationBubble(prompt, 'received');
      branchStep = nextStep;
      if (messageBody) messageBody.value = '';
      configureComposer();
      resizeMessageInput();
      setMessageStep('message', true, false);
    }

    function buildBranchSummary() {
      if (selectedBranch === 'Track Order') {
        var trackSummary = 'Track Order\nOrder number: ' + (branchAnswers.orderNumber || '');
        if (branchAnswers.additionalDetails) trackSummary += '\nAdditional details: ' + branchAnswers.additionalDetails;
        return trackSummary;
      }
      if (selectedBranch === 'Product Question') {
        return 'Product Question\nProduct: ' + (branchAnswers.product || '') + '\nQuestion: ' + (branchAnswers.question || '');
      }
      if (selectedBranch === 'Report Issue') return 'Report Issue\nDetails: ' + (branchAnswers.response || '');
      if (selectedBranch === 'Other') return 'Other\nMessage: ' + (branchAnswers.response || '');
      return messageBody ? messageBody.value.trim() : '';
    }

    function continueToReplyEmail() {
      if (messageBody) messageBody.value = buildBranchSummary();
      beginResponseDelay(function () {
        setMessageStep('email', true, false);
      });
    }

    function startBranch(branch) {
      selectedBranch = branch;
      branchStep = 'branch-prompt';
      branchAnswers = {};
      if (messageBody) messageBody.value = '';
      configureComposer();
      addConversationBubble(branch, 'sent');
      beginResponseDelay(function () {
        if (branch === 'Track Order') {
          showBranchPrompt("What's your order number?", 'order-number');
        } else if (branch === 'Product Question') {
          showBranchPrompt('What product can we help you with?', 'product');
        } else if (branch === 'Report Issue') {
          showBranchPrompt('Tell us what happened.', 'response');
        } else {
          showBranchPrompt('What can we help you with?', 'response');
        }
      });
    }

    function continueMessageFlow() {
      if (!messageBody) return;
      var message = messageBody.value.trim();
      if (!message) {
        if (bodyError) bodyError.hidden = false;
        messageBody.setAttribute('aria-invalid', 'true');
        focusElement(messageBody);
        return;
      }
      messageBody.value = message;
      if (bodyError) bodyError.hidden = true;
      messageBody.removeAttribute('aria-invalid');
      addConversationBubble(message, 'sent');

      if (!selectedBranch) {
        continueToReplyEmail();
      } else if (selectedBranch === 'Track Order' && branchStep === 'order-number') {
        branchAnswers.orderNumber = message;
        beginResponseDelay(function () {
          showBranchPrompt("Anything else you'd like us to know?", 'additional-details');
        });
      } else if (selectedBranch === 'Product Question' && branchStep === 'product') {
        branchAnswers.product = message;
        beginResponseDelay(function () {
          showBranchPrompt('What would you like to know about it?', 'question');
        });
      } else {
        if (selectedBranch === 'Track Order') {
          branchAnswers.additionalDetails = message;
        } else if (selectedBranch === 'Product Question') {
          branchAnswers.question = message;
        } else {
          branchAnswers.response = message;
        }
        continueToReplyEmail();
      }
    }

    function validateEmail() {
      if (!emailInput || emailInput.checkValidity()) {
        if (emailError) emailError.hidden = true;
        if (emailInput) emailInput.removeAttribute('aria-invalid');
        return true;
      }
      if (emailError) emailError.hidden = false;
      emailInput.setAttribute('aria-invalid', 'true');
      focusElement(emailInput);
      return false;
    }

    function updateInquiryContext() {
      var selectedVariant = productSection && productSection.querySelector('.product-variants option:checked');
      if (urlInput) urlInput.value = window.location.href.split('#')[0];
      if (skuInput && selectedVariant && selectedVariant.hasAttribute('data-sku')) {
        skuInput.value = selectedVariant.getAttribute('data-sku') || '';
      }
    }

    function rememberReturnState() {
      try {
        window.sessionStorage.setItem(returnStateKey, JSON.stringify({
          path: window.location.pathname,
          x: window.scrollX,
          y: window.scrollY,
          message: messageBody ? messageBody.value.trim() : '',
          email: emailInput ? emailInput.value.trim() : ''
        }));
      } catch (error) {
        return;
      }
    }

    function consumeReturnState() {
      var savedState;
      try {
        savedState = JSON.parse(window.sessionStorage.getItem(returnStateKey));
        window.sessionStorage.removeItem(returnStateKey);
      } catch (error) {
        return null;
      }
      return savedState && savedState.path === window.location.pathname ? savedState : null;
    }

    launcher.addEventListener('click', function () {
      openWidget(true);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeWidget);
    });

    if (startButton) {
      startButton.addEventListener('click', function () {
        if (composer) composer.hidden = false;
        if (greetingBubble) greetingBubble.hidden = false;
        setMessageStep('message', false, false);
        setView('messaging', true);
        resizeMessageInput();
      });
    }

    if (backButton) {
      backButton.addEventListener('click', function () {
        if (applyBusinessStatus().isOpen) {
          closeWidget();
        } else {
          resetInteraction();
          setView('landing', true);
        }
      });
    }

    if (continueButton) continueButton.addEventListener('click', continueMessageFlow);

    quickActions.forEach(function (button) {
      button.addEventListener('click', function () {
        startBranch(button.getAttribute('data-ers-message-quick-action') || button.textContent.trim());
      });
    });

    if (skipButton) {
      skipButton.addEventListener('click', function () {
        if (selectedBranch !== 'Track Order' || branchStep !== 'additional-details') return;
        branchAnswers.additionalDetails = '';
        continueToReplyEmail();
      });
    }

    if (messageBody) {
      messageBody.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' || event.shiftKey || event.isComposing) return;
        event.preventDefault();
        if (!messageBody.value.trim()) return;
        continueMessageFlow();
      });
      messageBody.addEventListener('input', function () {
        resizeMessageInput();
        if (messageBody.value.trim()) {
          if (bodyError) bodyError.hidden = true;
          messageBody.removeAttribute('aria-invalid');
        }
      });
    }

    if (emailInput) {
      emailInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' || event.isComposing) return;
        event.preventDefault();
        if (submitButton) submitButton.click();
      });
      emailInput.addEventListener('input', function () {
        if (emailInput.validity.valid) {
          if (emailError) emailError.hidden = true;
          emailInput.removeAttribute('aria-invalid');
        }
      });
      emailInput.addEventListener('invalid', function () {
        if (emailError) emailError.hidden = false;
        emailInput.setAttribute('aria-invalid', 'true');
      });
    }

    if (submitButton) {
      submitButton.addEventListener('click', function (event) {
        if (!validateEmail()) event.preventDefault();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && (widget.classList.contains('is-open') || widget.classList.contains('is-closing'))) {
        event.preventDefault();
        if (widget.classList.contains('is-open')) closeWidget();
        return;
      }
      containFocus(event);
    });

    document.addEventListener('click', function (event) {
      if ((!widget.classList.contains('is-open') && !widget.classList.contains('is-closing')) || panel.contains(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (widget.classList.contains('is-open')) closeWidget();
    }, true);

    if (productSection) productSection.addEventListener('product:variant:change', updateInquiryContext);
    if (form) {
      form.addEventListener('submit', function (event) {
        if (!messageBody || !messageBody.value.trim() || !validateEmail()) {
          event.preventDefault();
          if (messageBody && !messageBody.value.trim()) setMessageStep('message', true, false);
          return;
        }
        updateInquiryContext();
        rememberReturnState();
      });
    }

    applyBusinessStatus();
    updateInquiryContext();
    configureComposer();
    resizeMessageInput();

    if (success || serverErrors) {
      var returnState = consumeReturnState();
      if (returnState) {
        if (messageBody && !messageBody.value.trim()) messageBody.value = returnState.message || '';
        if (emailInput && !emailInput.value.trim()) emailInput.value = returnState.email || '';
        if (savedBody && !savedBody.textContent.trim()) savedBody.textContent = returnState.message || '';
      }
      if (savedBubble) savedBubble.hidden = !savedBody || !savedBody.textContent.trim();
      if (success) {
        widget.setAttribute('data-message-step', 'success');
      } else if (messageBody && messageBody.value.trim()) {
        setMessageStep('email', false, true);
      } else {
        setMessageStep('message', false, true);
      }
      setView('messaging', false);
      openWidget(false, returnState);
      window.requestAnimationFrame(focusCurrentState);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductMessageWidget);
  } else {
    initProductMessageWidget();
  }
})();
